import { ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { ICountry } from "../interfaces/icountry";
import { CountryInformationService } from "../services/countryinformation.service";
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";

@Injectable()
export class CountriesWithCategoryDetailResolver {

    constructor(private countryinformationservice: CountryInformationService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<ICountry[]> {
             
        // Log authentication state at resolver level          
        
        return this.countryinformationservice.getCountriesWithCategoryDetail().pipe(
            tap((countries) => {              
            }),
            catchError((error) => {
                
                if (error.status === 401) {
                }
                
                throw error;
            })
        );
    }
}